// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__e3tqr","input":"styles_input__3F1Es","btns":"styles_btns__3mhN7"};